export enum Radix {
  Decimal = 10,
}
